import jquery from 'jquery';
import $ from 'jquery';
import gsap from 'gsap';
import Swiper from 'swiper';
import slideTo from 'swiper';
import preload from 'preload-js';

import plugin from './components/plugins';
import App from './components/app';

//ANIMAZIONE PRELOADER
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    window.location.replace('http://mobile.anonymoushamburger.com');
}
const app = new App();

const handleFileComplete = (event) => {
    app.init();
};

const queue = new preload.LoadQueue(false);
const basePath = './assets/images'

queue.on('complete', handleFileComplete);

queue.loadManifest([
    `${basePath}/burger0-0.jpg`,
    `${basePath}/burger1-0.jpg`,
    `${basePath}/burger2-0.jpg`,
    `${basePath}/burger3-0.jpg`,
    `${basePath}/burger4-0.jpg`,
    `${basePath}/burger5-0.jpg`,
    `${basePath}/burger6-0.jpg`,
    `${basePath}/burger7-0.jpg`,
    `${basePath}/burger8-0.jpg`,
    `${basePath}/pata9-0.jpg`,
    `${basePath}/dolce10-0.jpg`
]);

// let tl = new TimelineMax({paused: true});
// $('.cont_burger').mouseenter((refr) => {
//     const target = refr.currentTarget;
//     const number = $(target).find('.cont-number-img');
//     const line = $(target).find('.linea-number-img');
//     const tl = new TimelineMax({paused: true});
//
//     tl.to(line, 0.3, {
//         x: -10
//     }).to(number, 0.4, {
//         x: -10
//     }, '-=0.1');
//
//     tl.play();
// });
//
// $('.cont_burger').mouseleave((refr) => {
//     const target = refr.currentTarget;
//     const number = $(target).find('.cont-number-img');
//     const line = $(target).find('.linea-number-img');
//     const tl = new TimelineMax({paused: true});
//
//     tl.to(number, 0.2, {
//         x: 0
//     }).to(line, 0.2, {
//         x: 0
//     });
//
//     tl.play();
// });



/** WEBPACK FOOTER **
 ** ./app.js
 **/